export const SEARCH_PRODUCT_REQUEST_DATA = "SEARCH_PRODUCT_REQUEST_DATA";
export const SEARCH_PRODUCT_RECEIVE_DATA = "SEARCH_PRODUCT_RECEIVE_DATA";
export const SEARCH_PRODUCT_REQUEST_DATA_FAILED = "SEARCH_PRODUCT_REQUEST_DATA_FAILED";

export const receiveData = (data) => ({ type: SEARCH_PRODUCT_RECEIVE_DATA, payload: data });
export const requestFailed = (error) => ({ type: SEARCH_PRODUCT_REQUEST_DATA_FAILED, payload: error });
